import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'bmc-refresh',
    template: `
    `,

})
export class RefreshComponent implements OnInit {


    constructor() { }

    ngOnInit() { }
}
